import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavigateOptions } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  walletId?: string | null
  getWithdrawalPath(walletId?: string | null): string
  withdrawalNavigateOptions?: NavigateOptions
}

export const TwoFactorAuthWithdrawalWarningModal: BaseModalType<Props> = (props) => {
  const { walletId, getWithdrawalPath, close, withdrawalNavigateOptions } = props

  const { t } = useTranslation()
  const navigate = useNavigate()
  const withdrawalPath = getWithdrawalPath(walletId)

  const handleAccept = () => {
    close()
    navigate(withdrawalPath, withdrawalNavigateOptions)
  }

  const handleEnable = () => {
    close()
    navigate('/profile/security-settings', withdrawalNavigateOptions)
  }

  return (
    <Modal>
      <Modal.Header canClose>{t('Sign up.Two-Factor Authentication')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('TwoFactorAuth.Two-Factor Authentication (2FA) is not enabled for Withdrawals')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleEnable}>
          {t('TwoFactorAuth.Enable 2FA')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleAccept}>
          {t('Profile.Accept the risk')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
